export const getMyInvoicesApp = {
  id: 57,
  name: "getmyinvoices",
  label: "GetMyInvoices",
  showTestConnection: true,
  logo: process.env.BASE_URL + "media/shopLogos/getMyInvoices.svg",
  additional_params: {
    requestHeaders: {
      "Content-Type": "application/json",
      "X-API-KEY": "{{token}}"
    },
    requestMethod: "GET",
    endpoint: "/accounts/v3/apiStatus"
  },
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_GET_MY_INVOICES_PRESET_ID
  }
};
